import React, { useState, useEffect } from 'react';
import {
  makeStyles,
  CssBaseline,
  Divider,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Hidden,
  useMediaQuery,
} from '@material-ui/core';
import {
  Dashboard as DashboardIcon,
  VpnKey as VpnKeyIcon,
  Assignment as AssignmentIcon,
} from '@material-ui/icons';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { useHistory } from 'react-router-dom';
import clsx from 'clsx';
import { Paths } from 'router/routes';
import { drawerWidth } from 'theme';
import { useSelector } from 'react-redux';
import { redirectToErp } from 'constants/auth';
import { ensureFreshAuthToken } from 'api/config';
import SideDrawer from './SideDrawer';
import AppToolbar from './AppToolbar';

const useStyles = makeStyles((theme) => ({
  appBarSpacer: theme.mixins.toolbar,
  root: {
    display: 'flex',
  },
  content: {
    flexGrow: 1,
    overflow: 'auto',
    padding: theme.spacing(3),
    [theme.breakpoints.up('md')]: {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginLeft: -drawerWidth,
    },
  },
  contentShift: {
    [theme.breakpoints.up('md')]: {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    },
  },
}));

const InternalTemplate = ({ children }) => {
  const classes = useStyles();
  const history = useHistory();
  const isMobileBreakpoint = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const [drawerOpen, setDrawerOpen] = useState(!isMobileBreakpoint);
  const [authReady, setAuthReady] = useState(false);
  const username = useSelector((state) => state.auth.username);

  const toggleDrawerOpen = () => setDrawerOpen(!drawerOpen);

  useEffect(() => {
    if (setDrawerOpen && isMobileBreakpoint) {
      setDrawerOpen(false);
    }
  }, [setDrawerOpen, isMobileBreakpoint]);

  const handleCertificados = () => history.push(Paths.CERTIFICADOS);
  const handleConsulta = () => history.push(Paths.CONSULTA);

  useEffect(() => {
    let cancelled = false;

    (async () => {
      const token = await ensureFreshAuthToken();
      if (cancelled) return;
      if (!token) {
        redirectToErp();
        return;
      }
      setAuthReady(true);
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  if (!authReady) {
    return null;
  }

  return (
    <div className={classes.root}>
      <CssBaseline />
      <Helmet>
        <title>Meus Docs - Página Inicial</title>
      </Helmet>
      <AppToolbar onMenuClick={toggleDrawerOpen} username={username} />
      <SideDrawer open={drawerOpen} onClose={toggleDrawerOpen}>
        <Hidden smDown implementation="css">
          <div className={classes.appBarSpacer} />
        </Hidden>
        <List>
          <ListItem button>
            <ListItemIcon>
              <DashboardIcon />
            </ListItemIcon>
            <ListItemText primary="Dashboard" />
          </ListItem>
          <Divider />
          <ListItem button onClick={handleConsulta}>
            <ListItemIcon>
              <AssignmentIcon />
            </ListItemIcon>
            <ListItemText primary="Consultar" />
          </ListItem>
          <ListItem button onClick={handleCertificados}>
            <ListItemIcon>
              <VpnKeyIcon />
            </ListItemIcon>
            <ListItemText primary="Certificados" />
          </ListItem>
        </List>

      </SideDrawer>
      <main
        className={clsx(classes.content, {
          [classes.contentShift]: drawerOpen,
        })}
      >
        <div className={classes.appBarSpacer} />
        {children}
      </main>
    </div>
  );
};

InternalTemplate.propTypes = {
  children: PropTypes.node.isRequired,
};

export default InternalTemplate;
